<template>
    <div class="card h-100 ui02-ap mb-1">
        <ul class="nav nav-tabs nav-tabs-underline nav-justified mb-0 ui02-ap-tabs" role="tablist">
            <li class="nav-item" role="presentation">
                <a href="#ui02d-tab-todo" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">To Do</a>
            </li>
            <li class="nav-item" role="presentation">
                <a href="#ui02d-tab-chat" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">Chat</a>
            </li>
            <li class="nav-item" role="presentation">
                <a href="#ui02d-tab-not" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
                    <Translate :path="'dizionario.base.NOTIFICATIONS'" />
                </a>
            </li>
        </ul>

        <div class="tab-content card-body ui02-ap-content">
            <div class="tab-pane fade show active" id="ui02d-tab-todo" role="tabpanel">
                <div :class="scroll ? 'ui02-ap-pane ui02-ap-scroll' : 'ui02-ap-pane ui02-ap-fixed'">
                    <Task :isDashboard="1" />
                </div>
            </div>

            <!-- Chat: stessa struttura e stessa API di Dashboard1. -->
            <div class="tab-pane fade" id="ui02d-tab-chat" role="tabpanel" style="min-height: 28.2rem; max-height: 28.2remx;">
                <div :class="scroll ? 'ui02-ap-pane ui02-ap-scroll' : 'ui02-ap-pane ui02-ap-fixed'">
                    <div class="dropdown-menu-scrollable pb-0"
                         v-for="msg in messaggiNonLetti.messaggi_non_letti"
                         :key="msg.ID_MESSAGE">
                        <a href="#" class="dropdown-item align-items-start text-wrap py-2">
                            <div class="status-indicator-container me-3">
                                <img v-if="msg.ID_PERSONA_FISICA > 0 && msg.URL_AVATAR != 'placeholder.jpg'"
                                     :src="filters.getImgPath('USERS', msg.URL_AVATAR)"
                                     class="w-40px h-40px rounded-pill" alt="" />
                                <img v-if="msg.URL_AVATAR == 'placeholder.jpg'"
                                     src="../../assets/images/face11.jpg" class="w-40px h-40px rounded-pill" alt="" />
                                <span class="status-indicator "
                                      :class="{ 'bg-danger': msg.STATO_ACCESSO == 0, 'bg-success': msg.STATO_ACCESSO == 1, 'bg-warning': msg.STATO_ACCESSO == 2 }"></span>
                            </div>
                            <div class="flex-1">
                                <span class="fw-semibold">{{ msg.USERNAME }}</span>
                                <span class="text-muted float-end fs-sm">{{ msg.DATA_INVIO }}</span>
                                <div class="text-muted">{{ msg.TEXT }}</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Notifiche: conservato esattamente come in Dashboard1. -->
            <div class="tab-pane fade" id="ui02d-tab-not" role="tabpanel" style="min-height: 28.2rem; max-height: 28.2remx;">
                <div :class="scroll ? 'ui02-ap-pane ui02-ap-scroll' : 'ui02-ap-pane ui02-ap-fixed'"></div>
            </div>
        </div>
    </div>
</template>

<script>
/* UI-02B - To Do / Chat / Notifiche estratto da Dashboard1.vue.
   Riusa il componente REALE Task (nessuna copia) e l'API reale della chat.
   Dashboard1 monta lo stesso componente: comportamento originale conservato.
   Nella Dashboard Manager scroll=true: card che riempie --ui02-h con scroll. */
import Task from "../Task.vue";

export default {
    name: "ActivityPanel",
    components: { Task },

    props: {
        scroll: { type: Boolean, default: false },
    },

    data() {
        return {
            filters: global.filters,
            messaggiNonLetti: { messaggi_non_letti: [] },
        };
    },
    mounted() {
        this.caricaMessaggiNonLetti();
    },

    methods: {
        /* Stessa API del blocco originale Dashboard1 (nessuna nuova route). */
        caricaMessaggiNonLetti() {
            if (!this.$root || !this.$root.utente || !this.$root.utente.ID_UTENTE) return;
            const utils = typeof global !== "undefined" && global.utils ? global.utils : null;
            if (!utils || typeof utils.get !== "function") return;
            utils.get("shared/chat/messaggi-non-letti",
                { FK_ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
                    if (response && response.esito == 0 && response.data) {
                        this.messaggiNonLetti = response.data;
                    }
                }, false);
        },
    },
};
</script>

<style scoped>
.ui02-ap {
    display: flex;
    flex-direction: column;
    min-height: 0;
    border: 1px solid #e9edf2;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .05);
    overflow: hidden;
}
.ui02-ap-tabs {
    flex-shrink: 0;
    padding: 0.53rem;
}
.ui02-ap-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 1rem;
}
.ui02-ap-content .tab-pane {
    flex: 1 1 auto;
    min-height: 0;
}
.ui02-ap-pane {
    position: relative;
}
/* Uso Dashboard1: pannelli a rame 33rem come l'originale. */
.ui02-ap-fixed {
    height: 33rem;
}
/* Uso Manager: riempie la card (altezza --ui02-h) con scroll interno. */
.ui02-ap-scroll {
    height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}
.ui02-ap-scroll::-webkit-scrollbar { width: 6px; }
.ui02-ap-scroll::-webkit-scrollbar-track { background: transparent; }
.ui02-ap-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
</style>